import React from 'react';
import { RadioGroupField as RadioGroupFieldType } from '../../types/optionTypes';

interface RadioGroupFieldProps {
    field: RadioGroupFieldType;
    value: any;
    onChange: (value: any) => void;
}

export const RadioGroupField: React.FC<RadioGroupFieldProps> = ({ field, value, onChange }) => {
    return (
        <div className="w-full">
            {field.label && (
                <label className="block text-sm font-medium text-gray-800 mb-2">
                    {field.label}
                    {field.required && <span className="text-red-500 ml-1">*</span>}
                    {field.tooltip && field.tooltip_type === 'popup' && (
                        <button
                            type="button"
                            className="ml-2 text-blue-600 hover:text-blue-800 inline-flex items-center"
                            onClick={() => {
                                const tooltipWindow = window.open('', 'tooltip', 'width=600,height=400,scrollbars=yes');
                                if (tooltipWindow) {
                                    tooltipWindow.document.write(`
                                        <html>
                                            <head><title>${field.label} - 詳細</title></head>
                                            <body style="font-family: sans-serif; padding: 20px;">
                                                ${field.tooltip}
                                            </body>
                                        </html>
                                    `);
                                }
                            }}
                            title="詳細を見る"
                        >
                            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                            </svg>
                        </button>
                    )}
                </label>
            )}

            <div className="space-y-2.5 bg-gray-50 p-3 rounded-md border border-gray-200">
                {field.values.map((option) => (
                    <label key={option.tempId} className="flex items-start space-x-2.5 cursor-pointer group hover:bg-white p-1.5 rounded transition-colors">
                        <input
                            type="radio"
                            name={field.name}
                            value={option.value}
                            checked={value === option.value}
                            onChange={(e) => onChange(e.target.value)}
                            className="mt-0.5 w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500 focus:ring-2"
                        />
                        <span className="text-sm text-gray-700 leading-relaxed flex-1">{option.label}</span>
                    </label>
                ))}
            </div>

            {field.description && (
                <div className="mt-1.5 text-xs text-gray-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: field.description }} />
            )}
            {field.errorMessage && (
                <p className="text-xs text-red-500 mt-1">{field.errorMessage}</p>
            )}
            {field.tooltip && field.tooltip_type !== 'popup' && (
                <div className="mt-1.5 text-xs text-gray-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: field.tooltip }} />
            )}
        </div>
    );
};
